import HeroHome from "./HeroHome";
import PartnersHome from "./PartnersHome";
import Sec3Home from "./Sec3Home";
import OutcomeHome from "./OutcomeHome";
// import CustomerHome from "./CustomerHome";
import ContactHome from "./ContactHome";

const Home = () => {
  return (
    <div className="home-page">
      <HeroHome />
      <Sec3Home />
      <OutcomeHome />
      {/* <CustomerHome /> */}
      <PartnersHome />
      <ContactHome />
    </div>
  );
};

export default Home;